<template>
  <v-container>
    <v-snackbar
      app
      top
      right
      v-model="display"
      :color="notification.status"
      :timeout="timeout"
      vertical
    >
      <div
        class="notification-title"
        data-cy="notification-title"
        v-if="notification.title && notification.title.length > 0"
      >
        {{ notification.title }}
      </div>
      <v-divider></v-divider>
      <div
        class="notification-text"
        data-cy="notification-text"
        v-for="message in notification.messages"
        v-bind:key="message"
      >
        {{ message }} <br />
      </div>
      <v-divider></v-divider>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          data-cy="notification-close-button"
          outlined
          v-bind="attrs"
          text
          @click="onClose"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import store from "@/store";

export default {
  data: () => ({
    display: false,
    color: "error",
    notification: {},
    timeout: 5000,
  }),

  methods: {
    onCallback(message) {
      if (this.notification.callback != null) {
        this.notification.callback(message);
        this.notification.callback = null;
      }
    },

    onClose() {
      this.display = false;
      this.onCallback("closed");
    },
  },

  store,

  watch: {
    display() {
      store.commit("setDisplayNotification", this.display);
      if (!this.display) {
        this.onCallback(this.notification.status);
      }
    },

    "$store.state.notification"() {
      this.notification = this.$store.getters.getNotification;
      this.display = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-title {
  font-weight: bold;
  font-size: 2em;
  margin-bottom: 20px;
  width: 100%;
}
.notification-text {
  font-size: 1.5 em;
  width: 100%;
}
.notification-close {
  margin-right: 5px;
}
</style>
